import { logger } from 'nightingale-app-console/src';
import { cleanExit } from './main-process/manager';
import { close as clientClose } from './main-process/client';
import { childServer } from './main-process/forks';

export function exit() {
  logger.warn('exiting...');
  Promise.all([childServer.kill(), clientClose(), cleanExit()]).then(() => {
    logger.warn('exit !');
    process.exit(0);
  });
}

process.on('SIGINT', exit);
process.on('SIGTERM', exit);
